export interface WebhookEventTypeDto {
  name: string;
  category: string;
  description: string;
}
